import { HttpService } from 'app/services';

export const NOTICE_GET_LIST = '@NOTICE/GET_LIST';
export const NOTICE_GET_LIST_SUCCESS = '@NOTICE/GET_LIST_SUCCESS';
export const NOTICE_GET_LIST_FAIL = '@NOTICE/GET_LIST_FAIL';

export const NOTICE_RECENT_PATIENT_ACTIVITY_GET_LIST = '@NOTICE/RECENT_PATIENT_ACTIVITY_GET_LIST';
export const NOTICE_RECENT_PATIENT_ACTIVITY_GET_LIST_SUCCESS = '@NOTICE/RECENT_PATIENT_ACTIVITY_GET_LIST_SUCCESS';
export const NOTICE_RECENT_PATIENT_ACTIVITY_GET_LIST_FAIL = '@NOTICE/RECENT_PATIENT_ACTIVITY_GET_LIST_FAIL';

const HELP_CENTRE_BASE_URL = 'https://mypaknghelpcentre.refined.site/space/NG/';
const RECENT_ACTIVITY_SIZE = 10;

const getHelpCentreArticleUrl = (contentId) => (contentId ? `${HELP_CENTRE_BASE_URL}${contentId}/` : null);

const normalizeNotice = (item) => {
  const content = item?.content ?? item;
  return {
    id: content.id,
    type: content.space?.name || content.type || '',
    date: content.history?.lastUpdated?.friendlyWhen || '',
    title: content.title || '',
    description: content.history?.lastUpdated?.by?.displayName
      ? `Updated by ${content.history.lastUpdated.by.displayName}`
      : '',
    url: getHelpCentreArticleUrl(content.id),
  };
};

export const getNotices = () => {
  return (dispatch) => {
    dispatch({ type: NOTICE_GET_LIST });
    HttpService.get('/api/helpdesk/notice')
      .then((resp) => {
        const raw = resp?.results ?? (Array.isArray(resp) ? resp : resp?.data ?? []);
        dispatch({ type: NOTICE_GET_LIST_SUCCESS, payload: raw.map(normalizeNotice) });
      })
      .catch(() => {
        dispatch({ type: NOTICE_GET_LIST_FAIL, payload: { message: 'error' } });
      });
  };
};

export const getRecentPatientActivity = () => {
  return (dispatch) => {
    dispatch({ type: NOTICE_RECENT_PATIENT_ACTIVITY_GET_LIST });
    HttpService.get('/api/medchangehistorys/recent-patient-activity', { size: RECENT_ACTIVITY_SIZE })
      .then((resp) => {
        const activities = Array.isArray(resp?.activities) ? resp.activities : [];
        dispatch({ type: NOTICE_RECENT_PATIENT_ACTIVITY_GET_LIST_SUCCESS, payload: activities });
      })
      .catch(() => {
        dispatch({ type: NOTICE_RECENT_PATIENT_ACTIVITY_GET_LIST_FAIL, payload: { message: 'error' } });
      });
  };
};
